/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(){this.pan=0,this.rotate=0,this.fov=0,this.sourceZoom=0,this.targetZoom=0}}export{t as CompareResult};
